import axios from "axios";
import { useState, useEffect, useRef } from "react";
import useHandleErrors from "./user.utils";
import { toast } from "react-toastify";

const useCountryCodes = () => {
  const [countryData, setCountryData] = useState({
    countryCodes: [],
    currencySymbols: [],
  });
  const [dataFetched, setDataFetched] = useState(false);
  const handleErrors = useHandleErrors();
  const token = localStorage.getItem("token");
  const hasFetchedRef = useRef(false);

  useEffect(() => {
    const fetchCountryData = async () => {
      try {
        const path = "/currencyCodes";
        const URL = process.env.REACT_APP_BE_URL + path;
        const response = await axios.get(URL, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        if (response.status === 200) {
          const countryCodes = response.data.map((country) => ({
            value: country.countryCode,
            label: `${country.countryName}`,
          }));

          const currencySymbols = response.data.map((country) => ({
            value: country.currencySymbol,
            label: `${country.countryName}`,
          }));

          setCountryData({
            countryCodes,
            currencySymbols,
          });
          setDataFetched(true);
        } else {
          handleErrors(response);
        }
      } catch (error) {
        console.error("Error fetching country data:", error);
        if (error.response) {
          handleErrors(error.response);
        } else {
          toast.error("Something went wrong. Please try again later.", {
            position: toast.POSITION.TOP_CENTER,
          });
        }
      }
    };

    if (!hasFetchedRef.current) {
      if (!dataFetched) {
        fetchCountryData();
      }
      hasFetchedRef.current = true;
  }
  }, [dataFetched, handleErrors, token]);

  return countryData;
};

export default useCountryCodes;
